import * as actions from "./dpcProfilesGetActions";
import { CURRENT_CHILD_ORGANIZATION_SET } from "store/domain/currentChildOrganization/currentChildOrganizationActions";

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [actions.DPC_PROFILES_GET_REQUEST]: (state, action) => ({
    ...state,
    loading: true,
    loaded: false,
    error: null,
    data: state.data,
  }),
  [actions.DPC_PROFILES_GET_REQUEST_SUCCESS]: (state, { data }) => {
    let { DPCProfiles, statistics } = data;

    return {
      ...state,
      loading: false,
      loaded: true,
      error: null,
      data: {
        DPCProfiles,
        statistics,
      },
    };
  },
  [actions.DPC_PROFILES_GET_REQUEST_FAILURE]: (state, action) => ({
    ...state,
    loading: false,
    loaded: false,
    error: action.error,
    data: null,
  }),
  [actions.DPC_PROFILES_GET_RESET]: () => initialState,
  [CURRENT_CHILD_ORGANIZATION_SET]: () => initialState,
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  loaded: false,
  loading: false,
  error: null,
  data: null,
};

export default function dpcProfilesGetReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
